// extracted by mini-css-extract-plugin
module.exports = {"labelButton":"styles_labelButton__ODmUn"};